import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy }  from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Store } from "@ngrx/store";
import { AppState } from "../../../reducers";
import { MessageActions } from '../../../actions'
import { ValidationService } from '../../../services'
import { AdditionalCharge } from '../../../models';
import { DecimalPipe } from '@angular/common';

@Component({
	selector: 'additional-charges-presentation',
	templateUrl: "./additional-charges.presentation.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [require("./additional-charges.presentation.scss")]
})

export class AdditionalChargesPresentation {
	@Output() public deleteAdditionalCharge = new EventEmitter<string>();
	@Output() public save = new EventEmitter<any[]>();

	private showDeleteWarning: boolean = false;
	private showFormErrors: boolean = false;
	private deleteRef: string;


	private controls: FormGroup[];

	constructor(
		private store: Store<AppState>,
		private formBuilder: FormBuilder,
		private messageActions: MessageActions
	) { }

	@Input() set additionalCharges(additionalCharges: AdditionalCharge[]) {
		if (additionalCharges) {
			this.createForm(additionalCharges);
		}
	}

	protected saveClicked() {
		if (this.controls.map(group => group.valid).reduce((a, b) => a && b)) {
			this.showFormErrors = false;
			this.save.emit(this.controls);
		} else {
			this.showFormErrors = true
			this.store.dispatch(this.messageActions.displayMessage("Bitte korrigieren Sie die rot umrandeten Felder.", "error"));
		}
	}

	protected deleteClicked(formGroup: FormGroup) {
		if (formGroup.value["deleteWithReference"]) {
			this.showDeleteWarning = true;
			this.deleteRef = formGroup.controls["deleteWithReference"].value;
		} else {
			this.controls.remove(formGroup);
		}
	}

	protected forceDeleteNo() {
		this.showDeleteWarning = false;
	}

	protected forceDeleteYes() {
		this.showDeleteWarning = false;
		this.deleteAdditionalCharge.emit(this.deleteRef);
		this.deleteRef = null;
	}

	private createForm(additionalCharges: AdditionalCharge[]) {
		this.controls = [];
		for (let additionalCharge of additionalCharges) {
			this.addAdditionalCharge(additionalCharge);
		}
	}

	private addAdditionalCharge(additionalCharge: AdditionalCharge) {
		let control = this.formBuilder.group({
				"self": additionalCharge._links.self.href,
				"deleteWithReference": additionalCharge._links.deleteWithReference.href,
				"description": [additionalCharge.description, [ValidationService.notOnlyWhitespace, Validators.required]],
				"price": [
					new DecimalPipe('DE').transform(additionalCharge.price.money.value, '1.2-2'),
					Validators.required
				],
				"vat": [
					new DecimalPipe('DE').transform(additionalCharge.price.vat, '1.0-2'),
					Validators.required
				]
			})

		this.controls.push(control);
	}

	private addBlankFormGroup() {
		let control = this.formBuilder.group({
				"self": null,
				"deleteWithReference": null,
				"description": ['', [ValidationService.notOnlyWhitespace, Validators.required]],
				"price": ['', Validators.required],
				"vat": ['', Validators.required]
			})

		this.controls.push(control);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/additional-charges/additional-charges.presentation.ts